module.exports = __webpack_public_path__ + "img/p3_5.780f65e8.png";